const link = [
  `<a href="https://new.ceo.ca/house-rules">here</a>`,
  `<a href="/guides/moderation">here</a>`,
];

const accountManagementArray = [
  {
    id: 1,
    title: "Changing your username",
    content:
      "Your username is permanent, though we make exceptions in special cases. To request a change to your username, \\ send an email to our support team at hello@ceo.ca from the email address linked to your account. In your email, please specify your current username and your desired new username. Our team will assess your request and get back to you within 2 to 3 business days.",
  },
  {
    id: 2,
    title: "Changing your email",
    content:
      "Contact the support team at hello@ceo.ca, from the email address currently associated with your account. Please include your current username and your intended new email address. The team will review your inquiry and get back to you in two to three business days.",
  },
  {
    id: 3,
    title: "Moderator issues and inquiries",
    content: `For moderator issues and inquiries, contact moderator@ceo.ca. Information on general CEO.CA house rules can be found ${link[0]}.`,
    secondaryContent: `For a comprehensive overview of moderation policies, please read our guide ${link[1]}.`,
  },
];

export default accountManagementArray;
